import Content from './Content';
import StatusCard from './components/Card';
import PaymentSuccessLayout from './components/PaymentSuccessLayout';
import PaymentSuccessProvider from './context';

const PaymentSuccess: React.FunctionComponent = function () {
  return (
    <PaymentSuccessProvider>
      <PaymentSuccessLayout>
        <StatusCard>
          <Content />
        </StatusCard>
      </PaymentSuccessLayout>
    </PaymentSuccessProvider>
  );
};

export default PaymentSuccess;
